export default __webpack_public_path__ + "static/media/download-icon.83e40b03.svg";